import React from 'react';
import PropTypes from 'prop-types';
/* Components */

/* Styles */
import './NextEpiButton.scss';
import Icon from '@dtvgo/icon';
import { useIntl } from 'react-intl';
import { PLAY_SOURCE_PAGE, redirectToPlayer } from '../../../../utils';
import PlayerButton from '../PlayerButton/PlayerButton';
import { history } from '../../../../state/configureStore';

function NextEpiButton({ nextAsset }) {
  const { formatMessage } = useIntl();

  const { redirect } = redirectToPlayer({
    assetId: nextAsset.vrioAssetId,
    history,
    isLive: false,
    replace: true,
    type: nextAsset.type,
    actionOrigin: nextAsset.actionOrigin,
    mainAssetId: nextAsset.episode?.showId ?? nextAsset.vrioAssetId,
    playSource: PLAY_SOURCE_PAGE.PLAYER,
    vmsId: nextAsset.vmsId,
  });

  //

  // const assetProps = {
  //   asset: {
  //     actionOrigin: nextAsset.actionOrigin,
  //     mainAssetId: nextAsset.episode?.showId ?? nextAsset.vrioAssetId,
  //     assetId: nextAsset.vrioAssetId,
  //     type: nextAsset.type,
  //     // playSource: PLAY_SOURCE_PAGE.PLAYER,
  //     vmsId: nextAsset.vmsId,
  //   },
  //   replace: true,
  // };

  return (
    <PlayerButton
      className=" dtv-common-c-go-next-epi-button-v2"
      tooltip=""
      onClick={() => {
        redirect();
      }}
      // eslint-disable-next-line react/jsx-props-no-spreading
      // {...assetProps}
    >
      <Icon name="next-episode" />
      {formatMessage({ id: 'player.nextEpi' })}
    </PlayerButton>
  );
}

NextEpiButton.propTypes = {
  nextAsset: PropTypes.shape({}),
};

NextEpiButton.defaultProps = {
  nextAsset: {},
};

export default NextEpiButton;
